import { Schema as Schema$1 } from 'effect';

var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/history.ts
var history_exports = {};
__export(history_exports, {
  Schema: () => Schema,
  breakCoalescing: () => breakCoalescing,
  canRedo: () => canRedo,
  canUndo: () => canUndo,
  init: () => init,
  record: () => record,
  redo: () => redo,
  undo: () => undo
});
var DEFAULT_LIMIT = 100;
var Schema = (Value) => Schema$1.Struct({
  past: Schema$1.Array(Value),
  future: Schema$1.Array(Value),
  coalescingKey: Schema$1.NullOr(Schema$1.String)
});
var init = () => ({
  past: [],
  future: [],
  coalescingKey: null
});
var canUndo = (model) => model.past.length > 0;
var canRedo = (model) => model.future.length > 0;
var record = (model, previous, options = {}) => {
  const coalescingKey = options.coalescingKey ?? null;
  if (coalescingKey !== null && coalescingKey === model.coalescingKey) {
    return { ...model, future: [], coalescingKey };
  }
  const limit = Math.max(1, options.limit ?? DEFAULT_LIMIT);
  return {
    past: [...model.past, previous].slice(-limit),
    future: [],
    coalescingKey
  };
};
var breakCoalescing = (model) => model.coalescingKey === null ? model : { ...model, coalescingKey: null };
var undo = (model, current) => {
  const value = model.past.at(-1);
  if (value === void 0) return void 0;
  return {
    value,
    history: {
      past: model.past.slice(0, -1),
      future: [current, ...model.future],
      coalescingKey: null
    }
  };
};
var redo = (model, current) => {
  const [value, ...future] = model.future;
  if (value === void 0) return void 0;
  return {
    value,
    history: {
      past: [...model.past, current],
      future,
      coalescingKey: null
    }
  };
};

export { history_exports as History };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map